import React from "react";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { QueryClientProvider } from "@tanstack/react-query";

// import { LanguageProvider } from "./hooks/use-language";

import Navbar from "./components/navbar/NavBar";
import { Footer } from "./components/Footer";
import { Toaster } from 'react-hot-toast';

// Pages
import Home from "./components/Home";
import About from "./components/AboutUs";
import Services from "./components/OurServices";
import Contact from "./components/ContactUs";
import Jobs from "./components/Jobs";
import Users from "./components/users/Users";
import TrafficJams from './components/TrafficJams';
import TripsDashboard from './components/trips/TripsDashboard';
import DriversMap from './components/driversMap/DriversMap';
import "keen-slider/keen-slider.min.css";
import "leaflet/dist/leaflet.css";
import queryClient from "./lib/queryClient";
import Fleet from "./components/Fleet";
import Media from "./components/media/Media";
import SupplierDashboard from "./components/orders/SupplierDashboard";
import Shipment from "./components/orders/Shipment";
import EmployeeDashboard from "./components/orders/EmployeeDashboard";
import ManagerDashboard from "./components/orders/ManagerDashboard";
import ShipmentsReport from "./components/orders/ShipmentsReport";
import SSOLogin from "./SsoLogin";

function App() {

  return (
    <QueryClientProvider client={queryClient}>
      <div className="flex flex-col min-h-screen">
        <Navbar />

        <Toaster position="top-center" reverseOrder={false} />
        <div className="flex-grow">
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/about" element={<About />} />
            <Route path="/services" element={<Services />} />
            <Route path="/contact" element={<Contact />} />
            <Route path="/jobs" element={<Jobs />} />
            <Route path="/Users" element={<Users />} />
            <Route path="/TrafficJams" element={<TrafficJams />} />
            <Route path="/Trips" element={<TripsDashboard />} />
            <Route path="/DriversMap" element={<DriversMap />} />
            <Route path="/Fleet" element={<Fleet />} />
            <Route path="/Media" element={<Media />} />
            <Route path="/SupplierDashboard" element={<SupplierDashboard />} />
            <Route path="/Shipment" element={<Shipment />} />
            <Route path="/EmployeeDashboard" element={<EmployeeDashboard />} />
            <Route path="/ManagerDashboard" element={<ManagerDashboard />} />
            <Route path="/ShipmentsReport" element={<ShipmentsReport />} />
            <Route path="/sso-login" element={<SSOLogin />} />
          </Routes>
        </div>

        <Footer />
      </div>
    </QueryClientProvider>
  );
}

export default App;
